import {
  TOAST_DURATION,
  TOAST_ERROR_DURATION,
  TOAST_NETWORK_DURATION,
} from 'src/app/config/global.config';
import { AppError, ErrorCode } from '../models/api-error';

/** Codes that describe an expected, recoverable state rather than a failure --
 *  shown as a warning (yellow) toast instead of a hard error (red) one. */
export const WARNING_CODES: ReadonlySet<string> = new Set([
  ErrorCode.ORDER_ALREADY_SENT_TO_ERP,
  ErrorCode.ORDER_SYNC_IN_PROGRESS,
]);

/**
 * How a failure should be presented, independent of who toasts it.
 *
 * The interceptor is the usual caller, but any effect that opts a request out of
 * it with `skipErrorToast()` takes on these decisions too -- so they live here
 * rather than inside the interceptor, where a caller could only duplicate them.
 */
export function severityFor(appError: AppError): 'ERROR' | 'WARNING' {
  return appError.code && WARNING_CODES.has(appError.code) ? 'WARNING' : 'ERROR';
}

/** Errors are always auto-dismissed (never Infinity); failures
 *  the user must read/act on linger longer. */
export function durationFor(appError: AppError): number {
  const { status } = appError;
  if (status === 0 || status >= 500) return TOAST_NETWORK_DURATION;
  if (status === 401 || status === 403) return TOAST_DURATION;
  return TOAST_ERROR_DURATION;
}
